<template>
  <div class="pirate">
    <div class="pirate_first pirate_public">
      <img class="men_top1" src="../assets/images/pirate/men_top2.png" alt />
      <img class="corsair" src="../assets/images/pirate/corsair2.png" alt />
      <img class="gold" src="../assets/images/pirate/gold.png" alt />
      <img class="in" src="../assets/images/pirate/in.png" alt />
      <div class="pirate_first_center">
        <p>
          予選：2020年8月21日12:00～22日12:00
          <br />本戦：2020年8月22日16:00配信開始
        </p>
        <p class="name">ゲスト：村上淳 鈴木たろう 園田賢 丸山奏子</p>
        <p class="sponsor">主催</p>
        <p class="assist">協力</p>
        <img class="mahjonc" src="../assets/images/elephant/mahjonc.png" alt />
        <img class="Yostar" src="../assets/images/elephant/Yostar.png" alt />
        <img class="cat" src="../assets/images/pirate/cat.png" alt />
        <div class="Dividing-line"></div>
        <img class="unext_pirates" src="../assets/images/pirate/unext_pirates2.png" alt />
      </div>
    </div>
    <div class="pirate_second pirate_public">
      <div class="square"></div>
      <div class="pirate_second_center">
        <p class="conference" v-scroll-reveal>大会概要</p>
        <p class="challenge" v-scroll-reveal>
          <span class="player-size">赤坂ドリブンズ</span>所属
          <span class="player">プロ雀士</span>の方々が
          <span class="player soul">雀魂</span>に
          <span class="player-size">参戦！</span>
          <br />
          <span class="player-size">Mリーガー</span>に
          <span class="player">挑戦</span>しよう!
        </p>
      </div>
    </div>
    <div class="pirate_third pirate_public">
      <div class="square"></div>
      <div class="pirate_third_center">
        <p class="way" v-scroll-reveal>参加方法</p>
        <p class="ranking" v-scroll-reveal>Yahooパスマーケットにて募集</p>
        <p class="ranking" v-scroll-reveal>
          ・
          <span>プレイヤー名</span>
        </p>
        <p class="ranking" v-scroll-reveal>
          ・
          <span>プレイヤーID</span>
        </p>
        <p class="ranking" v-scroll-reveal>
          ・
          <span>メールアドレス</span>
        </p>
        <p class="ranking" v-scroll-reveal>を入力して申し込みください。</p>
        <p class="ranking" v-scroll-reveal>受付期限：2020年8月20日(木) 12:00</p>
        <a
          href="https://passmarket.yahoo.co.jp/event/show/detail/01nbm4114wc10.html"
          class="site"
          v-scroll-reveal
          target="_blank"
        >申込み</a>
      </div>
    </div>
    <div class="pirate_fourth pirate_public">
      <div class="square"></div>
      <div class="pirate_fourth_center">
        <p v-scroll-reveal>賞品</p>
        <a class="prize_t" :href="require('../assets/images/pirate/prize2.png')" target="_blank">
          <img src="../assets/images/pirate/prize2.png" alt v-scroll-reveal />
        </a>
        <img class="prize2" src="../assets/images/pirate/prize2.png" alt v-scroll-reveal />
        <span v-scroll-reveal>
          ※上位20位までの方には賞品があります
          <br />※祈願の巻物およびコインは、雀魂内で使用できるアイテムです
          <br />※ドリブンズ選手が入賞した場合、参加賞は繰り上げになります
        </span>
      </div>
    </div>
    <div class="pirate_fifth pirate_public">
      <div class="square"></div>
      <div class="pirate_fifth_center">
        <a class="prize_t" :href="require('../assets/images/pirate/rules2.png')" target="_blank"></a>
        <p v-scroll-reveal>大会ルール</p>
        <div class="rules">
          <div class="rules_l" v-scroll-reveal>
            <p>
              大会の基本ルールは下記となります。
              <br />・競技は1卓4人
              <br />・全試合半荘戦で実施。
              <br />・長考時間：5+20秒
              <br />・25000点持ち・30000点返し
              <br />・赤ドラ3枚
              <br />・喰いタン：あり
              <br />・トビ終了：あり
              <br />・あがりやめ：なし
              <br />・テンパイやめ：なし
              <br />・同点は起親に近い方を優先。
              <br />・場所決めと親決めはゲーム側にて決定されます。
              <br />
            </p>
            <div class="competition">
              <p>競技ルール</p>
            </div>
          </div>
          <div class="rules_r">
            <div class="rules_r_t" v-scroll-reveal>
              <p>
                ランダム対戦で、
                <br />連続5戦のベストスコア
                <br />上位の合計12名が本戦に出場(時間内に何回でも打て、
                <br />その中の連続5戦の最高ポイントを採用)
                <br />◆予選時間: 8月21日12:00～22日12:00
              </p>
              <div class="competition">
                <p>予選システム</p>
              </div>
            </div>
            <div class="rules_r_b" v-scroll-reveal>
              <p>
                ◆16名で1回戦を行い、各卓上位2名が次戦に
                <br />進むトーナメント戦
                <br />◆16名→8名→4名となり、勝ち上がり4名
                <br />での決勝戦を行う
                <br />◆本戦時間: 2020年8月22日16:00～21:00（予定）
              </p>
              <div class="competition competition_s">
                <p>本戦システム</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="pirate_sixth pirate_public">
      <div class="square"></div>
      <div class="pirate_sixth_center">
        <a class="prize_t" :href="require('../assets/images/pirate/mc2.png')" target="_blank"></a>
        <div class="mc" v-scroll-reveal>
          <p>本戦放送MC</p>
          <div class="men"></div>
          <div class="competition">
            <p></p>
          </div>
        </div>
        <div class="mc_rule" v-scroll-reveal>
          <p>放送規則</p>
          <div class="hint">
            <p>
              ◆ 個人配信 ◆
              <br />5分間(300秒)以上の遅延を入れて
              <br />配信を行うようお願いいたします。
              <br />違反行為が確認された場合、
              <br />本大会失格及び一年間の
              <br />公式大会参加禁止処分とします。
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="pirate_seventh pirate_public">
      <div class="square"></div>
      <div class="pirate_seventh_center">
        <p v-scroll-reveal>ゲスト</p>
        <a
          class="information_t"
          :href="require('../assets/images/pirate/information2.png')"
          target="_blank"
        >
          <img src="../assets/images/pirate/information2.png" alt v-scroll-reveal />
        </a>
        <img
          class="information_p"
          src="../assets/images/pirate/information2.png"
          alt
          v-scroll-reveal
        />
      </div>
    </div>
    <footer-bar></footer-bar>
  </div>
</template>

<script>
import footerBar from "../components/footer";
export default {
  name: "pirate",

  components: {
    footerBar,
  },
  data: () => ({}),
  created() {},
  mounted() {},
  watch: {},
  computed: {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.pirate {
  .pirate_public {
    position: relative;
    width: 100%;
    padding-bottom: 56.29%;
    .square {
      position: absolute;
      left: 49%;
      top: -1.2%;
      height: 2.3%;
      width: 1.3%;
      z-index: 20;
      background: white;
      transform: rotate(45deg);
    }
  }
  .pirate_first {
    position: relative;
    width: 100%;
    padding-bottom: 56.29%;
    background: url(../assets/images/pirate/top0.png);
    background-size: cover;
    background-attachment: fixed;
    @media screen and (max-width: 600px) {
      background-attachment: scroll;
    }
    .men_top1 {
      position: absolute;
      width: 48.7%;
      bottom: 0;
    }
    .corsair {
      position: absolute;
      width: 56.21%;
      right: 5.45%;
      top: 8.74%;
    }
    .gold {
      position: absolute;
      width: 32.57%;
      right: 5.37%;
      top: 28.39%;
    }
    .in {
      position: absolute;
      width: 4.39%;
      right: 33.48%;
      top: 28.39%;
    }
    .pirate_first_center {
      position: absolute;
      right: 0;
      bottom: 0;
      width: 43.9%;
      height: 38%;
      p {
        text-align: left;
        color: white;
        font-family: "RodinProN-B";
        font-size: pxTorem(18px);
        line-height: pxTorem(42px);
        text-shadow: 0 0 pxTorem(3px) #312b26, 0 0 pxTorem(3px) #312b26,
          0 0 pxTorem(3px) #312b26;
        @media screen and (max-width: 600px) {
          font-size: MpxTorem(7px);
          line-height: MpxTorem(13px);
        }
      }
      .name {
        margin-top: 2%;
      }
      .sponsor {
        position: absolute;
        left: 0;
        top: 56%;
      }
      .assist {
        position: absolute;
        left: 35%;
        top: 56%;
      }
      //   background: violet;
      .unext_pirates {
        position: absolute;
        width: 16.07%;
        left: 11.25%;
        bottom: 13%;
      }
      .Dividing-line {
        position: absolute;
        background: white;
        width: MpxTorem(1px);
        height: 30%;
        left: 30%;
        bottom: 9%;
      }
      .cat {
        position: absolute;
        width: 14.67%;
        right: 50.17%;
        bottom: 9%;
      }
      .mahjonc {
        position: absolute;
        width: 5.5%;
        right: 38.75%;
        bottom: 9%;
      }
      .Yostar {
        position: absolute;
        width: 15%;
        top: 81.9%;
        left: 64.29%;
      }
    }
  }
  .pirate_second {
    position: relative;
    background: url(../assets/images/pirate/top1.png);
    background-size: cover;
    background-attachment: fixed;
    @media screen and (max-width: 600px) {
      background-attachment: scroll;
    }
    .pirate_second_center {
      box-sizing: border-box;
      padding-top: 5.26%;
      font-family: "RodinProN-B";
      text-align: center;
      position: absolute;
      width: 100%;
      height: 100%;
      left: 0;
      top: 0;
      p {
        font-size: pxTorem(40px);
        color: white;
        text-shadow: 0 0 pxTorem(3px) #312b26, 0 0 pxTorem(3px) #312b26,
          0 0 pxTorem(3px) #312b26;
        @media screen and (max-width: 600px) {
          font-size: MpxTorem(11px);
        }
      }
      .way {
        margin-bottom: 10%;
      }
      .conference {
        margin-bottom: 13%;
        @media screen and (max-width: 600px) {
          font-size: MpxTorem(16px);
        }
      }
      .challenge {
        line-height: pxTorem(82px);
        @media screen and (max-width: 600px) {
          line-height: MpxTorem(30px);
        }
      }
      .player-size {
        font-size: pxTorem(50px);
        @media screen and (max-width: 600px) {
          font-size: MpxTorem(15px);
        }
      }
      .player {
        font-size: pxTorem(50px);
        color: #d51742;
        @media screen and (max-width: 600px) {
          font-size: MpxTorem(15px);
        }
      }
      .soul {
        color: #e0c13e;
      }
    }
  }
  .pirate_third {
    position: relative;
    background: url(../assets/images/pirate/top2.png);
    background-size: cover;
    background-attachment: fixed;
    @media screen and (max-width: 600px) {
      background-attachment: scroll;
    }
    .pirate_third_center {
      box-sizing: border-box;
      padding-top: 5.26%;
      text-align: center;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      p {
        font-size: pxTorem(40px);
        font-family: "RodinProN-B";
        color: white;
        @media screen and (max-width: 600px) {
          font-size: MpxTorem(16px);
        }
        span {
          color: #ffdb44;
        }
      }
      .way {
        margin-bottom: 4%;
      }
      .ranking {
        font-size: pxTorem(29px);
        line-height: pxTorem(70px);
        @media screen and (max-width: 600px) {
          font-size: MpxTorem(10px);
          line-height: MpxTorem(20px);
        }
      }
      .site {
        position: absolute;
        left: 50%;
        transform: translate(-50%, -50%);
        line-height: pxTorem(62px);
        border-radius: pxTorem(10px);
        display: block;
        color: white;
        width: pxTorem(228px);
        height: pxTorem(62px);
        background: #ba052e;
        font-size: pxTorem(32px);
        font-family: "RodinProN-B";
        margin-top: 3%;
        @media screen and (max-width: 600px) {
          font-size: MpxTorem(6.5px);
          width: MpxTorem(60px);
          line-height: pxTorem(25px);
          height: MpxTorem(15px);
        }
      }
    }
  }
  .pirate_fourth {
    position: relative;
    background: url(../assets/images/pirate/top3.png);
    background-size: cover;
    background-attachment: fixed;
    @media screen and (max-width: 600px) {
      background-attachment: scroll;
    }
    .pirate_fourth_center {
      box-sizing: border-box;
      padding-top: 5.26%;
      text-align: center;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      font-family: "RodinProN-B";
      p {
        font-size: pxTorem(40px);
        font-family: "RodinProN-B";
        color: white;
        margin-bottom: 2%;
        @media screen and (max-width: 600px) {
          font-size: MpxTorem(16px);
          margin-bottom: 0%;
        }
      }
      img {
        width: 87%;
      }
      .prize_t {
        display: none;
        @media screen and (max-width: 600px) {
          display: block;
        }
      }
      .prize2 {
        @media screen and (max-width: 600px) {
          display: none;
        }
      }
      span {
        line-height: 120%;
        position: absolute;
        font-size: pxTorem(15px);
        color: white;
        right: 7%;
        text-align: left;
        bottom: 3.5%;
        @media screen and (max-width: 600px) {
          font-size: MpxTorem(5px);
          line-height: MpxTorem(8px);
          right: 0.6%;
          bottom: 2%;
        }
      }
    }
  }
  .pirate_fifth {
    position: relative;
    background: url(../assets/images/pirate/top4.png);
    background-size: cover;
    background-attachment: fixed;
    @media screen and (max-width: 600px) {
      background-attachment: scroll;
    }
    .pirate_fifth_center {
      box-sizing: border-box;
      padding-top: 5.26%;
      text-align: center;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      font-family: "RodinProN-B";
      color: white;
      font-size: pxTorem(40px);
      a {
        position: absolute;
        display: none;
        z-index: 2;
        @media screen and (max-width: 600px) {
          display: block;
          width: 100%;
          height: 100%;
        }
      }
      p {
        margin-bottom: 2.78%;
        @media screen and (max-width: 600px) {
          font-size: MpxTorem(16px);
        }
      }
      .rules {
        box-sizing: border-box;
        width: 100%;
        height: 74.58%;
        padding: 0 3% 0 8.3%;
        display: flex;
        justify-content: space-between;
        .rules_l {
          box-sizing: border-box;
          width: 43%;
          height: 100%;
          background: rgba(0, 0, 0, 0.6);
          position: relative;
          .competition {
            width: pxTorem(50px);
            font-size: pxTorem(18px);
            position: absolute;
            background: url(../assets/images/pirate/dices1.png);
            background-size: 100% 100%;
            height: 46%;
            top: -4%;
            left: -5%;
            padding-top: 18%;
            box-sizing: border-box;
            @media screen and (max-width: 600px) {
              font-size: MpxTorem(5px);
              width: MpxTorem(15px);
              line-height: MpxTorem(10px);
            }
            p {
              margin: 0 auto;
              width: pxTorem(20px);
              word-wrap: break-word;
              line-height: pxTorem(20px);
              @media screen and (max-width: 600px) {
                width: MpxTorem(5px);
                line-height: MpxTorem(7px);
              }
            }
          }
          p {
            margin-left: 7.98%;
            text-align: left;
            font-size: pxTorem(18px);
            line-height: pxTorem(33px);
            margin-top: 10.63%;
            @media screen and (max-width: 600px) {
              font-size: MpxTorem(5px);
              line-height: MpxTorem(10px);
            }
          }
        }
        .rules_r {
          width: 48%;
          height: 100%;
          font-size: pxTorem(18px);
          position: relative;
          line-height: pxTorem(33px);
          .rules_r_t {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 42.9%;
            background: rgba(0, 0, 0, 0.6);
            p {
              margin-top: 4.3%;
              @media screen and (max-width: 600px) {
                font-size: MpxTorem(5px);
                line-height: MpxTorem(10px);
              }
            }
            .competition {
              width: pxTorem(50px);
              font-size: pxTorem(18px);
              position: absolute;
              background: url(../assets/images/pirate/dices2.png);
              background-size: 100% 100%;
              height: 105%;
              top: -8%;
              left: -4%;
              padding-top: 13.7%;
              box-sizing: border-box;
              @media screen and (max-width: 600px) {
                font-size: MpxTorem(5px);
                width: MpxTorem(15px);
                line-height: MpxTorem(10px);
              }
              p {
                margin: 0 auto;
                width: pxTorem(20px);
                word-wrap: break-word;
                line-height: pxTorem(20px);
                @media screen and (max-width: 600px) {
                  width: MpxTorem(5px);
                  line-height: MpxTorem(7px);
                }
              }
            }
          }
          .rules_r_b {
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
            height: 42.9%;
            background: rgba(0, 0, 0, 0.6);
            p {
              margin-top: 4.2%;
              @media screen and (max-width: 600px) {
                font-size: MpxTorem(5px);
                line-height: MpxTorem(10px);
              }
            }
            .competition {
              width: pxTorem(50px);
              font-size: pxTorem(18px);
              position: absolute;
              background: url(../assets/images/pirate/dices3.png);
              background-size: 100% 100%;
              height: 105%;
              top: -8%;
              left: -4%;
              padding-top: 13.7%;
              box-sizing: border-box;
              @media screen and (max-width: 600px) {
                font-size: MpxTorem(5px);
                width: MpxTorem(15px);
                line-height: MpxTorem(10px);
              }
              p {
                margin: 0 auto;
                width: pxTorem(20px);
                word-wrap: break-word;
                line-height: pxTorem(20px);
                @media screen and (max-width: 600px) {
                  width: MpxTorem(5px);
                  line-height: MpxTorem(7px);
                }
              }
            }
          }
        }
      }
    }
  }
  .pirate_sixth {
    position: relative;
    background: url(../assets/images/pirate/top5.png);
    background-size: cover;
    background-attachment: fixed;
    @media screen and (max-width: 600px) {
      background-attachment: scroll;
    }
    .pirate_sixth_center {
      box-sizing: border-box;
      padding-top: 10%;
      text-align: center;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      font-family: "RodinProN-B";
      color: white;
      font-size: pxTorem(40px);
      text-shadow: 0 0 pxTorem(5px) #312b26, 0 0 pxTorem(0px) #312b26,
        0 0 pxTorem(5px) #312b26;
      display: flex;
      @media screen and (max-width: 600px) {
        font-size: MpxTorem(16px);
      }
      a {
        z-index: 2;
        position: absolute;
        display: none;
        @media screen and (max-width: 600px) {
          display: block;
          width: 100%;
          height: 100%;
        }
      }
      .mc {
        width: 50%;
        height: 100%;
        position: relative;
        p {
          margin-bottom: 12%;
           @media screen and (max-width: 600px) {
            margin-bottom: 4%;
          }
        }
        .men {
          margin-top: 2%;
          width: 65.67%;
          height: 73.73%;
          background: url(../assets/images/pirate/icon_men2.png);
          background-size: cover;
          margin: 0 auto;
          @media screen and (max-width: 600px) {
            width: 71.67%;
            height: 81.73%;
          }
        }
        .competition {
          display: none;
          width: pxTorem(47px);
          font-size: pxTorem(20px);
          position: absolute;
          background: url(../assets/images/pirate/dices0.png);
          background-size: 100% 100%;
          height: 40%;
          top: 28%;
          left: 72%;
          padding-top: 16%;
          box-sizing: border-box;
          @media screen and (max-width: 600px) {
            font-size: MpxTorem(5px);
            width: MpxTorem(15px);
            line-height: MpxTorem(10px);
            left: 70%;
          }
          p {
            font-family: "RodinProN-B";
            margin: 0 auto;
            width: pxTorem(30px);
            word-wrap: break-word;
            line-height: pxTorem(22px);
            @media screen and (max-width: 600px) {
              width: MpxTorem(5px);
              line-height: MpxTorem(7px);
            }
          }
        }
      }
      .mc_rule {
        width: 50%;
        height: 100%;
        p {
          margin-bottom: 5%;
        }
        .hint {
          background: url(../assets/images/pirate/sigh.png);
          background-size: 100% 100%;
          font-size: pxTorem(20px);
          margin: 0 auto;
          width: 66.87%;
          height: 61.16%;
          padding-top: 6%;
          box-sizing: border-box;
          p {
            margin-top: 10%;
            line-height: 206%;
            @media screen and (max-width: 600px) {
              font-size: MpxTorem(6px);
              line-height: MpxTorem(12px);
            }
          }
        }
      }
    }
  }
  .pirate_seventh {
    position: relative;
    background: url(../assets/images/pirate/top6.png);
    background-size: cover;
    background-attachment: fixed;
    @media screen and (max-width: 600px) {
      background-attachment: scroll;
    }
    .pirate_seventh_center {
      box-sizing: border-box;
      padding-top: 5.26%;
      text-align: center;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      font-family: "RodinProN-B";
      color: white;
      font-size: pxTorem(40px);
      @media screen and (max-width: 600px) {
        font-size: MpxTorem(16px);
      }
      .information_t {
        display: none;
        @media screen and (max-width: 600px) {
          display: block;
          img {
            width: 100%;
          }
        }
      }
      .information_p {
        width: 100%;
        @media screen and (max-width: 600px) {
          display: none;
        }
      }
    }
  }
}
</style>
